















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: { }
})
export default class Report extends Vue {
    @Prop({default:{}})
    reportData;
    img=require("../../assets/index_icon01.png")

    goDetail(){
        this.$router.push(`/home/report/det/${this.reportData.id}`)
    }
}
